import React from 'react'
import {Navigate, Outlet} from 'react-router-dom'
import {AdminAuth} from '../../app/modules/auth/core/AdminAuth'

function Protected() {
  return AdminAuth() ? <Outlet /> : <Navigate to='/auth' />
}

export default Protected
